/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

export const API_ERROR_EVENTS = {
  API_ERROR: 'API_ERROR',
};

export interface ApiErrorParams {
  label: string;
  errorCode?: string;
  errorMessage?: string;
  statusCode?: number;
  endpoint?: string;
}

export const ERROR_TRACKING_EVENTS = {
  ERROR_TRACKING: 'errors',
};

export const SERVICE_NAMES = {
  STATION_SEARCH: 'Station Search',
  STATE_PROVINCE: 'State Province',
  UPSELL_BUNDLE: 'Upsell Bundle',
  SEARCH_AGGREGATOR_DEEPLINK: 'OTA Deeplink',
  SEARCH_AGGREGATOR: 'Search Aggregator',
  SEARCH_AGGREGATOR_PAGINATION: 'Search Aggregator Pagination',
  GUEST_AGGREGATOR: 'Guest Aggregator',
  CHECKOUT: 'Checkout',
  MOT_FLIGHT_SUBSIDIES: 'MOT Flight Subsidies',
  LFC: 'LFC',
  FLIGHT_RECOMMENDATIONS: 'Flight Recommendations',
  FLIGHTS_AUTHENTICATION: 'Flights Authentication',
  BP_CALCULATOR: 'BP Calculator',
  CURRENCY_FORMAT: 'Currency Format',
  NEAREST_AIRPORTS: 'Nearest Airports',
  CHANGE_FLIGHT: 'Change Flight',
};

// Broad service-layer classification, not just HTTP API failures - a
// validation error thrown before any request goes out (e.g. a missing
// filter/token) is neither an api nor a network failure.
export type ServiceErrorType =
  | 'api'
  | 'validation'
  | 'network'
  | 'payment'
  | 'authentication';

export interface ErrorTrackingParams {
  errorType: ServiceErrorType;
  errorCode?: string | number;
  errorDescription: string;
  errorMessage: string;
  labelSeparator?: string;
  screenName: string;
  service: string;
}
